import { useMutation, useQueryClient } from "react-query";
import { ECoursesQueryKeys } from "api/endpoints/courses";
import { addCourseToStudent } from "api/services/courses";
import { logError } from "utils/notifications";
import { TAddCourseToStudentBody } from "types/api/course";
import { TApiError } from "types/api/error";

export const useAddCourseToStudent = () => {
  const queryClient = useQueryClient();
  return useMutation<void, TApiError, TAddCourseToStudentBody>(
    addCourseToStudent,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(ECoursesQueryKeys.getAllCourses);
      },
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
